<script setup lang="ts">
import { cn } from '@/lib/utils'
import type { HTMLAttributes } from 'vue'

const props = defineProps<{
    class?: HTMLAttributes['class']
}>()
</script>

<template>
    <tr
        data-slot="table-row"
        :class="cn('hover:bg-muted/50 data-[state=selected]:bg-muted border-b transition-colors [&_td:last-child_div]:border-none', props.class)"
    >
        <slot />
    </tr>
</template>
